<template>
	<div class="w-100">
		<PaymentBillRestaurant v-if="source == 'orderbil'" />
		<PaymentBillHotel v-if="source == 'gp-pms'" />
	</div>
</template>

<script>
	import PaymentBillRestaurant from '../restaurant/PaymentBillGeneral';
	import PaymentBillHotel from '../hotel/PaymentBill';

	export default {
		components:{
			PaymentBillRestaurant,
			PaymentBillHotel
		},
		computed:{
			source(){
				let src = this.$route.query.src
				if(src) return src
				return ''
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/general/PaymentBill.vue